import { useLang } from 'contexts/intl';
import { useMemo } from 'react';
import { paths } from 'router';
import { Paths } from 'utils/pathFactory';

export function usePaths() {
  const { lang } = useLang();

  const connectedPaths = useMemo(
    () =>
      Object.entries(paths).reduce((connectedPaths, [pathName, props]) => {
        connectedPaths[pathName] = {
          ...props,
          generate(params: any) {
            return props.generate({ lang, ...params });
          },
        };

        return connectedPaths;
      }, {} as Paths),
    [lang],
  );

  return connectedPaths;
}
